export * from '@primeuix/themes/material/inplace';
export { default } from '@primeuix/themes/material/inplace';
